import { CropIcon } from './Icons';
import LoadingIcon from './LoadingIcon';

interface DownloadMenuProps {
  file: any;
  dimensions: any;
  downloadingSize: string;
  loadingCropTool: boolean;
  className: string;
  downloadFile: (id: number, filename: string, size: string) => void;
  openCropTool: (id: number) => void;
}

const DownloadMenu = ({
  file,
  dimensions,
  downloadingSize,
  loadingCropTool,
  className,
  downloadFile,
  openCropTool,
}: DownloadMenuProps) => {
  const renderSizeButton = (
    size: string,
    label: string,
    dimensionKey: string,
    className = 'inline-block px-2 py-1 text-xs text-left hover:text-gray-400 size-button'
  ) =>
    downloadingSize === size ? (
      <div className="my-[3px] mx-2">
        <LoadingIcon />
      </div>
    ) : (
      <button
        onClick={() => downloadFile(file.ID, file.file, size)}
        className={className}
      >
        <span>{label}</span>
        {'  '}
        <span className="text-gray-400">
          ({dimensions?.[dimensionKey]?.width}x{dimensions?.[dimensionKey]?.height})
        </span>
      </button>
    );

  return (
    <div className={`download-menu ${className}`}>
      {renderSizeButton('small', 'Small', 'small')}
      {renderSizeButton('medium', 'Medium', 'medium')}
      {renderSizeButton('large', 'Large', 'large')}
      <div className="w-full my-[3px] border-b border-gray-200" />
      {renderSizeButton(
        'file',
        'Original',
        'original',
        'inline-block px-2 py-1 mb-1 text-xs text-left hover:text-gray-400 size-button'
      )}
      {loadingCropTool ? (
        <div className="my-[3px] mx-2">
          <LoadingIcon className="w-[20px] h-[20px] text-accent animate-spin" />
        </div>
      ) : (
        <button
          onClick={() => openCropTool(file.ID)}
          className="inline-flex gap-2 px-2 py-1 text-xs text-left hover:text-gray-400 size-button"
        >
          <CropIcon />
          <span> Crop image</span>
        </button>
      )}
    </div>
  );
};

export default DownloadMenu;
